import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";


const UsersManagement = () => {
    const [query, setQuery] = useState("");
    const [users, setUsers] = useState([])
    const [showChangeRole, setShowChangeRole] = useState(false);
    const [role, setRole] = useState("");

    const [idSelectUserChange, setIdSelectUserChange] = useState([]);
    const [selectedUserChange, setSelectedUserChange] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [statusHandle, setStatusHandle] = useState("");
    const [selectedItems, setSelectedItems] = useState([]);


    const { apiUrl } = useSelector(state => state.api);

    // get all Users
    const getAllUser = async () => {
        try {
            const response = await axios.get(`${apiUrl}/dashboard/users`, {
                headers: { token: localStorage.getItem('token') }
            })
            const getAllUser = response.data;
            setUsers(getAllUser);
        } catch (err) {
            console.error(err.message);
        }
    };

    useEffect(() => {
        getAllUser();
    }, [apiUrl]);

    // Search  all Users

    const handleSearch = async () => {
        const data = { query };
        try {
            if (!query) {
                setCurrentPage(1);
                getAllUser();
            } else {
                const response = await axios.get(`${apiUrl}/dashboard/users/query`, {
                    params: data,
                    headers: { token: localStorage.getItem('token') }
                });
                const getAllUser = response.data;
                setUsers(getAllUser);
                setCurrentPage(1);
            }
        } catch (err) {
            console.error(err.message);
            console.log(err.response);
            // setStatusSearch(err.response.data)
        }
    };
    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            console.log("Enter");
            handleSearch();
        }
    };

    const handleInputChange = (event) => {
        setQuery(event.target.value);
    };






    // handle Show Change Role
    const handleShowChangeRole = (user_id) => {
        console.log(user_id);
        setShowChangeRole(true);
        setIdSelectUserChange(user_id);
        const findUser = users.filter(item => user_id.includes(item.user_id));
        setSelectedUserChange(findUser);

    }



    // onchange handle Set Role
    const handleSetRole = (event) => {
        setRole(event.target.value);
    };

    // handle Change Role
    const handleChangeRole = async (idSelectUserChange) => {
        console.log(idSelectUserChange);
        const data = { user_id: idSelectUserChange, user_role: role };
        try {
            if (idSelectUserChange && role) {
                const response = await axios.put(`${apiUrl}/dashboard/users/editrole`, data,
                    {
                        headers: { token: localStorage.getItem('token') }
                    });
                console.log(response.data);
                setStatusHandle(response.data);

                const responseUserAgain = await axios.get(`${apiUrl}/dashboard/users`, {
                    headers: { token: localStorage.getItem('token') }
                })
                const getAllUser = responseUserAgain.data;
                setUsers(getAllUser);

                setTimeout(() => {
                    setStatusHandle("");
                    setShowChangeRole(false);

                }, 1500);
            } else {
                setStatusHandle("Select the role!!")
            }
        } catch (error) {
            console.error(error.message);
        }

    };




    //handle delete Checkbox checked
    const handleCheckboxChange = (e, product_id) => {
        if (e.target.checked) {
            setSelectedItems([...selectedItems, product_id]);
        } else {
            setSelectedItems(selectedItems.filter(id => id !== product_id));
        }
    }


    //create index list orders
    const productsPerPage = 3;//number of product on page
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentUsers = users.slice(indexOfFirstProduct, indexOfLastProduct);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    return (
        <div className="col-md-10 bg-light p-2 ">
            <div className="row d-flex justify-content-center">

                <div class="col-md-10 text-center">

                    <div className="input-group mb-3 ">
                        <input
                            type="text" className="form-control" aria-label="Search" aria-describedby="basic-addon2"
                            placeholder="You are can search by name user, ID or phone number"
                            value={query}
                            onChange={handleInputChange}
                            onKeyDown={handleKeyDown}
                        />
                        <button
                            className="btn btn-outline-secondary" type="button" id="search-button"
                            onClick={() => handleSearch(query)}
                        >
                            Search
                        </button>
                    </div>

                    <div className="input-group mb-3 ">
                        {(selectedItems.length > 1) && <div>
                            <button type="button" class="btn btn-warning button-edit  m-1"
                                // onClick={() => handleRemoveProduct(product.product_id)}
                                onClick={() => handleShowChangeRole(selectedItems)}
                            >Change Role checked</button>
                        </div>}
                    </div>
                    <div class="col-md-12 d-flex justify-content-center mt-4 mt-md-3">
                        <table className="table-product-dashboard">
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Infomation</th>
                                    <th>Address</th>
                                    <th>Role</th>
                                    <th></th>

                                </tr>
                            </thead>
                            <tbody>
                                {currentUsers?.map((user, ind) => (
                                    <tr key={user.user_id}>
                                        <td >
                                            <input type="checkbox" class="checked" name={user.user_name}
                                                idcheck={user.user_id} style={{ margin: '5%' }}
                                                checked={selectedItems.includes(user.user_id)}
                                                onChange={(e) => handleCheckboxChange(e, user.user_id)}
                                            />
                                            <img src={apiUrl + "/" + user.user_avatar} alt={user.user_name} style={{ height: "80px", width: " 80px" }} />
                                        </td>
                                        <td>{user.user_name}<br />
                                            {user.user_email}<br />
                                            {user.user_phone}</td>
                                        <td> {user.user_address} {user.user_state} {user.user_city}</td>
                                        <td> {user.user_role}</td>

                                        <td>

                                            <button type="button" class="btn btn-light button-edit" style={{ size: 5 }}
                                                onClick={() => handleShowChangeRole([user.user_id])}
                                            >Edit</button>

                                        </td>

                                    </tr>

                                ))}
                            </tbody>

                        </table>

                    </div >


                    <div className="pagination-dashboard">
                        <nav aria-label="Page navigation">
                            <ul className="pagination">
                                {Array.from({ length: Math.ceil(users.length / productsPerPage) },
                                    (_, i) => i + 1).map((pageNumber) => (
                                        <li className={`page-item ${currentPage === pageNumber ? 'active' : ''}`} key={pageNumber}>
                                            <button className="page-link" onClick={() => handlePageChange(pageNumber)}>
                                                {pageNumber}
                                            </button>
                                        </li>
                                    )
                                    )}
                            </ul>
                        </nav>
                    </div>

                    {showChangeRole && (users.length > 0) && (
                        <div class="modal-container-dashboard">
                            <div class="my-modal-dashboard" >
                                <div class="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Change Role User</h5>
                                    <button type="button" class="btn-close" aria-label="Close" onClick={() => setShowChangeRole(false)}></button>
                                </div>

                                <div className="modal-body-dashboard">
                                    <select name="permission" size="1" value={role} onChange={handleSetRole} className="text-center">
                                        <option >Select Roles for User</option>
                                        <option value="user">User</option>
                                        <option value="read">Read</option>
                                        <option value="write">Write</option>
                                        <option value="banned">Banned</option>
                                    </select>
                                    <br />
                                    {(selectedUserChange.length <= 8) ? (<div class="text-start">
                                        <div class="row">
                                            {/* {selectedUserRemove.map((item) => (
                                                <div class="col-12 col-md-6">
                                                    <img src={apiUrl+ "/"  + item.product_img} style={{ height: "50px", width: "50px", margin: '1%' }} />
                                                    {item.product_name.substring(0, 15) + "..."}
                                                    <br />
                                                </div>
                                            ))} */}
                                        </div>
                                    </div>) : (<div>
                                        {/* {selectedUserRemove.map((item) => (
                                            <img src={apiUrl+ "/"  + item.product_img} style={{ height: "50px", width: "50px", margin: '1%' }} />
                                        ))} */}
                                    </div>)
                                    }

                                    <br />
                                    Are you sure you want to change the role for the User?
                                </div>
                                {statusHandle && <div class="statusChangePass">{statusHandle} </div>}
                                <div class="d-flex">
                                    <button type="button" class="btn btn-secondary w-50 mx-1" onClick={() => setShowChangeRole(false)}>Close</button>
                                    <button type="button" className="btn btn-danger w-50 mx-1" onClick={() => handleChangeRole(idSelectUserChange)}>Change</button>

                                </div>

                            </div>
                        </div>
                    )}
                    {/* <!-- Modal --> */}


                </div>


            </div>

        </div >



    )
}
export default UsersManagement;